/**
 * @flow
 * @relayHash de54a132c67ff8a65e2d7fb6c2ba9fad
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SendTwoFactorSetupCodeInput = {|
  setupToken: string,
  phone: string,
|};
export type SendTwoFactorSetupCodeMutationVariables = {|
  input: SendTwoFactorSetupCodeInput
|};
export type SendTwoFactorSetupCodeMutationResponse = {|
  +sendTwoFactorSetupCode: {|
    +success: boolean
  |}
|};
export type SendTwoFactorSetupCodeMutation = {|
  variables: SendTwoFactorSetupCodeMutationVariables,
  response: SendTwoFactorSetupCodeMutationResponse,
|};
*/


/*
mutation SendTwoFactorSetupCodeMutation(
  $input: SendTwoFactorSetupCodeInput!
) {
  sendTwoFactorSetupCode(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SendTwoFactorSetupCodeInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "sendTwoFactorSetupCode",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendTwoFactorSetupCodePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SendTwoFactorSetupCodeMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SendTwoFactorSetupCodeMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "SendTwoFactorSetupCodeMutation",
    "id": null,
    "text": "mutation SendTwoFactorSetupCodeMutation(\n  $input: SendTwoFactorSetupCodeInput!\n) {\n  sendTwoFactorSetupCode(input: $input) {\n    success\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '12aa4da12af56b2b534e9f8f42180e7c';
module.exports = node;
